const showPopup = (userObj) => {
    return {
        type: "SHOW_POPUP_DIRECT",
        payload: userObj
    }
}

const showPopupByPopupName = (userObj) => {
    return {
        type: "SHOW_POPUP_BY_POPUP_NAME",
        payload: userObj
    }
}

const pushPopupData = (userObj) => {
    return {
        type: "PUSH_POPUP_DATA",
        payload: userObj
    }
}

const pushAllPopupData = (userObj) => {
    return {
        type: "PUSH_ALL_POPUP_DATA",
        payload: userObj
    }
}


const hidePopup = (userObj) => {
    return {
        type: "HIDE_POPUP",
        payload: userObj
    }
}

export default {
    showPopup,
    showPopupByPopupName,
    pushPopupData,
    pushAllPopupData,
    hidePopup
}